/* eslint no-console: ["error", { allow: ["log"] }] */

import { N2UnbindHandlers } from './N2';
import Publications from '../controllers/Publications';

const Controller = {
  Publications,
};

class ControllerLoader {
  static load() {
    const controller = $('#controller-loader-params').data('controller');
    const action = $('#controller-loader-params').data('action');

    if (controller && Controller[controller] !== undefined) {
      this.controller = new Controller[controller]($('#controller-loader-params').data());
      if (this.controller[action]) {
        if (process.env.RAILS_ENV === 'development') {
          console.log(`Found ${controller}#${action}`);
        }
        return this.controller[action]();
      }
      if (process.env.RAILS_ENV === 'development') {
        console.log(`Not found ${controller}#${action}`);
      }
    } else if (process.env.RAILS_ENV === 'development') {
      console.log(`Not found ${controller}#${action}`);
    }
    return undefined;
  }

  static unload() {
    N2UnbindHandlers();
    if (this.controller) {
      if (this.controller.unload) { this.controller.unload(); }
      this.controller = null;
    }
    return undefined;
  }
}

export default ControllerLoader;
